import PropTypes from 'prop-types'

const propTypes = {
  classes: PropTypes.object.isRequired,
  save: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
}

export default propTypes
